module.exports = __webpack_public_path__ + "static/media/DebitCard.9db48a5f.svg";